import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrophy } from "@fortawesome/free-solid-svg-icons";
import { stockPini } from "../../constants/links";
import { ADD_USER_ROUTE, LEADERBOARD_ROUTE } from "../../constants/routes";
import { useUser, userIsAdmin } from "../../helpers/user";
import UserSearch from "./usersearch";

const Styles = styled.div`
    color: white !important;

    .navbar { flex-wrap: nowrap; }

    .brand-full { display: inline; }
    .brand-short { display: none; }

    @media (max-width: 400px) {
        .brand-full { display: none; }
        .brand-short { display: inline; }
    }
`
export default function Header() {
    const { user } = useUser()
    if (!user) return null
    const isAdmin = userIsAdmin(user)

    return <Styles>
    <Navbar bg="dark" variant='dark' expand="sm">
        <Navbar.Brand href="/">
            <img height='30px' src={stockPini}/>
            {' '}
            <span className='brand-full'>Rate My Pini</span>
            <span className='brand-short'>RMP</span>
        </Navbar.Brand>

        <UserSearch/>

        <Nav className="ml-auto" style={{ alignItems: 'center' }}>
            <Nav.Link href={LEADERBOARD_ROUTE}>
                <FontAwesomeIcon icon={faTrophy}/>
            </Nav.Link>
            <NavDropdown
                alignRight
                title={user.username}
            >
                {isAdmin && <NavDropdown.Item href={ADD_USER_ROUTE}>Add User</NavDropdown.Item>}
                <NavDropdown.Item href="/logout">Logout</NavDropdown.Item>
            </NavDropdown>
        </Nav>
    </Navbar>
    </Styles>
}